// Copyright © 2024 Ory Corp
// SPDX-License-Identifier: Apache-2.0
export var FlowType;
(function (FlowType) {
    FlowType["Login"] = "login";
    FlowType["Registration"] = "registration";
    FlowType["Recovery"] = "recovery";
    FlowType["Verification"] = "verification";
    FlowType["Settings"] = "settings";
    FlowType["Error"] = "error";
    FlowType["OAuth2Consent"] = "oauth2_consent";
})(FlowType || (FlowType = {}));
